import { render, staticRenderFns } from "./CreateEmailInvitation.vue?vue&type=template&id=b2ae5d62&scoped=true"
import script from "./CreateEmailInvitation.vue?vue&type=script&lang=js"
export * from "./CreateEmailInvitation.vue?vue&type=script&lang=js"
import style0 from "./CreateEmailInvitation.vue?vue&type=style&index=0&id=b2ae5d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ae5d62",
  null
  
)

export default component.exports